module.exports = __webpack_public_path__ + "static/media/game-image.18fe5eae.png";